function ServiceHotel() {
  return (
    <div
      className="serviceHotel"
      style={{
        backgroundImage: `url("/images/bgr_ex.jpg")`,
      }}
    >
      <img className="img-fluid imgTop" src="/images/JO247.png" alt="" />
      <div className="container">
        <div className="row SS247">
          <div className="col-lg-6 col-12 itemBox">
            <img className="img-fluid" src="/images/JO247-logo.png" alt="" />
          </div>
          <div className="col-lg-6 col-12 itemBox">
            <h5>Lounge bar - Vui thả ga!!!</h5>
            <div className="row">
              <div className="col-lg-6 col-12 col-md-8 itemBox">
                <p>
                  Được ví như trái tim của SOJO, là sự kết hợp táo bạo giữa quầy
                  lễ tân thông minh, ẩm thực độc đáo, không gian làm việc sáng
                  tạo và chill-bar thư thái khi đêm về.
                </p>
              </div>
              <div className="col-lg-6 col-12  col-md-4 iconStyle">
                <img src="/images/247-icon.png" alt="" />
                <img src="/images/bar-icon.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-12 itemBox">
            <img
              className="img-fluid"
              src="/images/kiosk-screen-icon.png"
              alt=""
            />
          </div>
          <div className="col-lg-6 col-12 itemBox">
            <div className="iconStyle">
              <img
                className="img-fluid"
                src="/images/check-in-icon.png"
                alt=""
              />
              <img
                className="img-fluid"
                src="/images/check-out-icon.png"
                alt=""
              />
            </div>
            <h5 className="title">Nhận / Trả phòng</h5>
            <div className="textStyle">
              <p>
                Được ví như trái tim của SOJO, là sự kết hợp táo bạo giữa quầy
                lễ tân thông minh, ẩm thực độc đáo, không gian làm việc sáng tạo
                và chill-bar thư thái khi đêm về.
              </p>
            </div>
          </div>
        </div>
        <div className="row rowRes">
          <div className="col-lg-6 col-12 itemBox">
            <img className="img-fluid" src="/images/food.png" alt="" />
          </div>
          <div className="col-lg-6 col-12 itemBox">
            <div className="iconStyle">
              <img className="img-fluid" src="/images/dinner-icon.png" alt="" />
            </div>
            <h5 className="title">Ẩm thực</h5>
            <div className="textStyle">
              <p>
                Sáng tạo một chút mới trên những gì đã quen, SOJO mang tới những
                món quà địa phương thú vị trong hương vị ẩm thực của mình.
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6  col-12 itemBox">
            <img
              className="img-fluid"
              src="/images/vending-machine.png"
              alt=""
            />
          </div>
          <div className="col-lg-6 col-12 itemBox">
            <div className="iconStyle">
              <img
                className="img-fluid"
                src="/images/vending-machine-icon.png"
                alt=""
              />
            </div>
            <h5 className="title">Mua sắm</h5>
            <div className="textStyle">
              <p>
                Những vật dụng cần thiết khi dịch chuyển, món quà lưu niệm ý
                nghĩa, hay một món ăn khi bụng đói bất chợt, tất cả đều được
                chúng tôi chu đáo chuẩn bị cho JO bất kể ngày đêm.
              </p>
            </div>
          </div>
        </div>
        <div className="row rowRes">
          <div className="col-lg-6 col-12 itemBox">
            <img className="img-fluid" src="/images/lockers.png" alt="" />
          </div>
          <div className="col-lg-6 col-12 itemBox">
            <div className="iconStyle">
              <img
                className="img-fluid"
                src="/images/lockers-icon.png"
                alt=""
              />
            </div>
            <h5 className="title">Tủ đồ cá nhân</h5>
            <div className="textStyle">
              <p>
                Thả hành lý vào, JO tắt "chế độ cồng kềnh" và bật "chế độ rảnh
                tay "
              </p>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6 col-12 itemBox">
            <img className="img-fluid" src="/images/relax-room.png" alt="" />
          </div>
          <div className="col-lg-6 col-12 itemBox">
            <div className="iconStyle">
              <img className="img-fluid" src="/images/relax-icon.png" alt="" />
            </div>
            <h5 className="title">Phòng thư giãn</h5>
            <div className="textStyle">
              <p>
                Thảnh thơi tận hưởng không gian yên tĩnh tại phòng thư giãn của
                SOJO mà không vướng bận hành lí ngay cả khi cần trả phòng muộn
                hay lấy phòng sớm.
              </p>
            </div>
          </div>
        </div>
        <div className="row rowRes">
          <div className="col-lg-6 col-12 itemBox">
            <img className="img-fluid" src="/images/GYM.png" alt="" />
          </div>
          <div className="col-lg-6 col-12 itemBox">
            <div className="iconStyle">
              <img className="img-fluid" src="/images/GYM-icon.png" alt="" />
            </div>
            <h5 className="title">GYM</h5>
            <div className="textStyle">
              <p>Giữ nhịp tập luyện ngay cả khi đang "di chuyển".</p>
            </div>
          </div>
        </div>
        <div className="row ">
          <div className="col-lg-6 col-12 itemBox">
            <img className="img-fluid" src="/images/games.png" alt="" />
          </div>
          <div className="col-lg-6 col-12 itemBox">
            <div className="iconStyle">
              <img className="img-fluid" src="/images/game-icon.png" alt="" />
            </div>
            <h5 className="title">Games</h5>
            <div className="textStyle">
              <p>Cười khoái chí với các games miễn phí!</p>
            </div>
          </div>
        </div>
        <div className="row rowRes">
          <div className="col-lg-6 col-12 itemBox">
            <img className="img-fluid" src="/images/laundry.png" alt="" />
          </div>
          <div className="col-lg-6 col-12 itemBox">
            <div className="iconStyle">
              <img
                className="img-fluid"
                src="/images/laundry-icon.png"
                alt=""
              />
            </div>
            <h5 className="title">Giặt là</h5>
            <div className="textStyle">
              <p> Khu giặt sấy tự phục vụ để JO chủ động như ở nhà.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ServiceHotel;
